// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NumericRangeEntityConfig__container___rZJ-4{display:flex}.NumericRangeEntityConfig__left___3tEZC{flex:1}.NumericRangeEntityConfig__right___2FYRA{flex:1}\n", ""]);
// Exports
exports.locals = {
	"container": "NumericRangeEntityConfig__container___rZJ-4",
	"left": "NumericRangeEntityConfig__left___3tEZC",
	"right": "NumericRangeEntityConfig__right___2FYRA"
};
module.exports = exports;
